import { useQuery } from "@apollo/client";

import { Team } from "Types/Team";

import { getTeamsQuery } from "../Queries/queries";

type TeamLoadData = {
    teams: Array<Team>;
    loading: boolean;
};

export function useTeamsData(): TeamLoadData {
    const { loading, data } = useQuery<{ getTeams: Array<Team> }>(getTeamsQuery, {
        fetchPolicy: "network-only",
    });

    return {
        teams: data?.getTeams ?? [],
        loading,
    };
}
